<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <!-- generalInformation -->
      <section class="tw-mt-4 tw-mb-12">
        <details
          open
          class="tw-relative tw-bg-white dark:tw-bg-dark-500 tw-rounded-[5px] tw-border-[#29293d]"
          style="border-style: solid"
          formGroupName="generalInformation"
        >
          <summary
            class="tw-font-semibold tw-top-[-15px] tw-right-[15px] ltr:tw-left-[15px]"
          >
            <span class="tw-text-xl tw-font-semibold">
              {{ pageVocabs + "legends.generalInformation" | translate }}
            </span>
          </summary>

          <div class="row tw-p-4 tw-pt-10">
            <!-- isRealPerson -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <custom-select-search
                [label]="fields + 'isRealPerson'"
                [items]="
                  $any([
                    { value: false, name: 'common.legalPerson' | translate },
                    { value: true, name: 'common.realPerson' | translate }
                  ])
                "
                [control]="form?.get('generalInformation.isRealPerson')"
                optionTitle="name"
                optionValue="value"
                [removable]="false"
                [(value)]="model.isRealPerson"
                (valueChange)="changeValidation()"
              >
              </custom-select-search>
            </div>

            <!-- name -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.name"
                [control]="form?.get('generalInformation.name')"
                [label]="
                  model.isRealPerson
                    ? fields + 'workplaceTitle'
                    : fields + 'organName'
                "
                [maxLength]="64"
              >
              </form-field>
            </div>

            <!-- nationalId -->
            <div
              class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4"
              *ngIf="!model.isRealPerson"
            >
              <form-field
                [(value)]="model.nationalId"
                [control]="form?.get('generalInformation.nationalId')"
                [label]="fields + 'nationalId'"
                type="tel"
                [maxLength]="11"
              >
              </form-field>
            </div>

            <!-- nationalCode -->
            <div
              class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4"
              *ngIf="model.isRealPerson && formPageConfig.isEditMode"
            >
              <form-field
                [(value)]="model.nationalId"
                [control]="form?.get('generalInformation.nationalId')"
                label="common.nationalCode"
                [minLength]="model.isForeigner ? 12 : 10"
                [maxLength]="model.isForeigner ? 12 : 10"
                type="tel"
              >
              </form-field>
            </div>

            <!-- phone -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [value]="model.phone"
                (valueChange)="model.phone = $event; user.phone = $event"
                [control]="form?.get('generalInformation.phone')"
                [label]="
                  model.isRealPerson
                    ? fields + 'workplacePhone'
                    : 'common.phone'
                "
                type="tel"
                [maxLength]="11"
              >
              </form-field>
            </div>

            <ng-container *ngIf="!model.isRealPerson">
              <!-- economicCode -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <form-field
                  [(value)]="model.economicCode"
                  [control]="form?.get('generalInformation.economicCode')"
                  [label]="fields + 'economicCode'"
                  [minLength]="11"
                  [maxLength]="12"
                >
                </form-field>
              </div>

              <!-- ceoFullName -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <form-field
                  [(value)]="model.ceoName"
                  [control]="form?.get('generalInformation.ceoName')"
                  [label]="fields + 'ceoFullName'"
                  [maxLength]="64"
                >
                </form-field>
              </div>

              <!-- ceoNationalCode -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <form-field
                  [value]="model.ceoNationalCode"
                  (valueChange)="
                    model.ceoNationalCode = $event; user.nationalCode = $event
                  "
                  [control]="form?.get('generalInformation.ceoNationalCode')"
                  [label]="fields + 'ceoNationalCode'"
                  type="tel"
                  [maxLength]="10"
                >
                </form-field>
              </div>

              <!-- ceoMobile -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <form-field
                  [value]="model.ceoMobile"
                  (valueChange)="model.ceoMobile = $event; user.mobile = $event"
                  [control]="form?.get('generalInformation.ceoMobile')"
                  [label]="fields + 'ceoMobile'"
                  (change)="convertMobile()"
                  [maxLength]="12"
                  type="tel"
                  [isMobileField]="true"
                >
                </form-field>
              </div>
            </ng-container>

            <!-- zipCode -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [value]="model.zipCode"
                (valueChange)="model.zipCode = $event; user.zipCode = $event"
                [control]="form?.get('generalInformation.zipCode')"
                [label]="
                  model.isRealPerson
                    ? fields + 'workplaceZipCode'
                    : 'common.zipCode'
                "
                type="tel"
                [maxLength]="10"
              >
              </form-field>
            </div>

            <!-- address -->
            <div class="md:tw-w-1/2">
              <form-textarea
                class="tw-w-full"
                [label]="
                  model.isRealPerson
                    ? fields + 'workplaceAddress'
                    : 'common.address'
                "
                [(value)]="model.address"
                [control]="form?.get('generalInformation.address')"
                [rows]="1"
                (valueChange)="user.address = model.address"
              >
              </form-textarea>
            </div>
          </div>
        </details>
      </section>

      <!-- systemInformation -->
      <section class="tw-mb-12">
        <details
          open
          class="tw-relative tw-bg-white dark:tw-bg-dark-500 tw-rounded-[5px] tw-border-[#29293d]"
          style="border-style: solid"
          formGroupName="systemInformation"
        >
          <summary
            class="tw-font-semibold tw-top-[-15px] tw-right-[15px] ltr:tw-left-[15px]"
          >
            <span class="tw-text-xl tw-font-semibold">
              {{ pageVocabs + "legends.systemInformation" | translate }}
            </span>
          </summary>

          <div class="tw-p-4 tw-pt-10">
            <div class="row">
              <!-- parentId -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <organization-select-search
                  *ngIf="!isSelectedOrganizationAdmin"
                  type="descendantAndItselfList"
                  [label]="fields + 'parentId'"
                  [control]="form?.get('systemInformation.parentId')"
                  [(value)]="model.parentId"
                  (valueChange)="onChangeParentId($event)"
                  (onError)="onClose()"
                >
                </organization-select-search>
                <form-field
                  *ngIf="isSelectedOrganizationAdmin"
                  [value]="model.parentName"
                  [control]="form?.get('systemInformation.parentId')"
                  [label]="fields + 'parentId'"
                >
                </form-field>
              </div>

              <!-- domainId -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <customer-domain-select-search
                  *ngIf="!isSelectedOrganizationAdmin"
                  [control]="form?.get('systemInformation.domainId')"
                  [label]="fields + 'domainId'"
                  [(value)]="model.domainId"
                  (onError)="onClose()"
                >
                </customer-domain-select-search>
                <form-field
                  *ngIf="isSelectedOrganizationAdmin"
                  [value]="model.domainName"
                  [control]="form?.get('systemInformation.domainId')"
                  [label]="fields + 'domainId'"
                >
                </form-field>
              </div>

              <div class="sm:tw-w-full lg:tw-w-2/3 xl:tw-w-1/2">
                <app-date-time-picker
                  [config]="dateTimeConfig"
                  (dateTime)="model.expireDate = $event"
                >
                </app-date-time-picker>
              </div>

              <!-- startTime -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <timepicker
                  [value]="sendStartTime"
                  (value)="sendStartTime = $event"
                  [control]="form?.get('systemInformation.sendStartTime')"
                  [maxTime]="sendEndTime"
                  [label]="fields + 'sendStartTime'"
                  [confirmBtnClass]="'btn' | themeColor"
                >
                </timepicker>
              </div>

              <!-- endTime -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <timepicker
                  [value]="sendEndTime"
                  (value)="sendEndTime = $event"
                  [control]="form?.get('systemInformation.sendEndTime')"
                  [label]="fields + 'sendEndTime'"
                  [minTime]="sendStartTime"
                >
                </timepicker>
              </div>

              <!-- maximumPhoneNumber -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <form-field
                  [value]="
                    model.maximumPhoneNumber == -1
                      ? '∞'
                      : model.maximumPhoneNumber
                  "
                  (valueChange)="
                    $event == '∞' ? -1 : (model.maximumPhoneNumber = $event)
                  "
                  [control]="form?.get('systemInformation.maximumPhoneNumber')"
                  [label]="fields + 'maximumPhoneNumber'"
                  [min]="-1"
                >
                </form-field>
              </div>

              <!-- maximumUser -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <form-field
                  [value]="model.maximumUser == -1 ? '∞' : model.maximumUser"
                  (valueChange)="
                    $event == '∞' ? -1 : (model.maximumUser = $event)
                  "
                  [control]="form?.get('systemInformation.maximumUser')"
                  [label]="fields + 'maximumUser'"
                  [min]="-1"
                >
                </form-field>
              </div>

              <!-- maximumOrganization -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <form-field
                  [value]="
                    model.maxOrganization == -1 ? '∞' : model.maxOrganization
                  "
                  [control]="form?.get('systemInformation.maxOrganization')"
                  (valueChange)="
                    $event == '∞' ? -1 : (model.maxOrganization = $event)
                  "
                  [label]="fields + 'maxOrganization'"
                  [min]="-1"
                >
                </form-field>
              </div>

              <!-- maxPhonebook -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <form-field
                  [value]="model.maxPhonebook == -1 ? '∞' : model.maxPhonebook"
                  (valueChange)="
                    $event == '∞' ? -1 : (model.maxPhonebook = $event)
                  "
                  [control]="form?.get('systemInformation.maxPhonebook')"
                  [label]="fields + 'maxPhonebook'"
                  [min]="-1"
                >
                </form-field>
              </div>

              <!-- maxCustomFiled -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <form-field
                  [value]="
                    model.maxCustomFiled == -1 ? '∞' : model.maxCustomFiled
                  "
                  (valueChange)="
                    $event == '∞' ? -1 : (model.maxCustomFiled = $event)
                  "
                  [label]="fields + 'maxCustomFiled'"
                  [min]="-1"
                  [control]="form?.get('systemInformation.maxCustomFiled')"
                >
                </form-field>
              </div>

              <!-- panelPrice -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <form-field
                  [(value)]="model.panelPrice"
                  [label]="fields + 'panelPrice'"
                  [hasCurrency]="true"
                  type="tel"
                  [hasNumberSeparator]="true"
                  [control]="form?.get('systemInformation.panelPrice')"
                  [min]="0"
                >
                </form-field>
              </div>

              <!-- group-price-category -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <group-price-category-select-search
                  [removable]="isSelectedOrganizationAdmin ? false : true"
                  [id]="model.id == 1 ? 1 : model.parentId"
                  [isDisabled]="
                    (!model.parentId && model.id != 1) ||
                    (currentUserInfo.organizationId == model.id &&
                      model.id != 1)
                  "
                  [control]="
                    form?.get('systemInformation.groupPriceCategoryId')
                  "
                  [value]="model.groupPriceCategoryId"
                  (valueChange)="
                    model.groupPriceCategoryId = $event;
                    model.groupPriceId = null
                  "
                  (isShowGroupPrice)="isShowGroupPrice = $event"
                  (onError)="onClose()"
                >
                </group-price-category-select-search>
              </div>

              <!-- group-price-id -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
                <group-price-select-search
                  [isShowGroupPrice]="isShowGroupPrice"
                  [id]="model.groupPriceCategoryId"
                  [removable]="isSelectedOrganizationAdmin ? false : true"
                  [isDisabled]="
                    !model.groupPriceCategoryId ||
                    (currentUserInfo.organizationId == model.id &&
                      model.id != 1)
                  "
                  [control]="form?.get('systemInformation.groupPriceId')"
                  [value]="model.groupPriceId"
                  (valueChange)="model.groupPriceId = $event"
                  (onError)="onClose()"
                >
                </group-price-select-search>
              </div>

              <div class="md:tw-w-1/2"></div>

              <!-- header -->
              <div class="md:tw-w-1/2">
                <form-textarea
                  class="tw-w-full"
                  label="common.header"
                  [(value)]="model.smsHeader"
                  [control]="form?.get('header')"
                  [rows]="2"
                  maxlength="100"
                >
                </form-textarea>
              </div>

              <!-- signature -->
              <div class="md:tw-w-1/2">
                <form-textarea
                  class="tw-w-full"
                  label="common.signature"
                  [(value)]="model.signature"
                  [control]="form?.get('signature')"
                  [rows]="2"
                >
                </form-textarea>
              </div>

              <!-- descriptions -->
              <div class="md:tw-w-1/2">
                <form-textarea
                  class="tw-w-full"
                  label="common.description"
                  [(value)]="model.descriptions"
                  [control]="form?.get('descriptions')"
                  [rows]="2"
                  maxlength="100"
                >
                </form-textarea>
              </div>
            </div>

            <div class="row tw-mt-3">
              <!-- isActive -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isActive"
                  [(ngModel)]="model.isActive"
                >
                  {{ "common.isActive" | translate }}</mat-slide-toggle
                >
              </div>

              <!-- isAllowLink -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isAllowLink"
                  [(ngModel)]="model.isAllowLink"
                >
                  {{ fields + "isAllowLink" | translate }}</mat-slide-toggle
                >
              </div>

              <!-- isTax -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isTax"
                  [(ngModel)]="model.isTax"
                >
                  {{ fields + "isTax" | translate }}</mat-slide-toggle
                >
              </div>

              <!-- isShowGeneralAccount -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isShowGeneralAccount"
                  [(ngModel)]="model.isShowGeneralAccount"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text class="tw-leading-7">
                      {{ fields + "isShowGeneralAccount" | translate }}
                    </span>
                    <div full-text class="full-text-display">
                      {{ fields + "isShowGeneralAccount" | translate }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- isShowGeneralNumbers -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isShowGeneralNumbers"
                  [(ngModel)]="model.isShowGeneralNumbers"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text class="tw-leading-7">
                      {{ fields + "isShowGeneralNumbers" | translate }}
                    </span>
                    <div full-text class="full-text-display">
                      {{ fields + "isShowGeneralNumbers" | translate }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>
              <!-- isActiveSend -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isActiveSend"
                  [(ngModel)]="model.isActiveSend"
                >
                  {{ fields + "isActiveSend" | translate }}</mat-slide-toggle
                >
              </div>
              <!-- isConfirmMessage -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isConfirmMessage"
                  [(ngModel)]="model.isConfirmMessage"
                >
                  {{
                    fields + "isConfirmMessage" | translate
                  }}</mat-slide-toggle
                >
              </div>

              <!-- isActiveAllTime -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isActiveAllTime"
                  [(ngModel)]="model.isActiveAllTime"
                  (change)="changeIsActiveAll($event)"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text class="tw-leading-7">
                      {{ fields + "isActiveAllTime" | translate }}
                    </span>
                    <div full-text class="full-text-display">
                      {{ fields + "isActiveAllTime" | translate }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- isHaveBlackListDeliveryProcess -->
              <div
                *ngIf="permissionService.userState()?.isSuperAdmin"
                class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2"
              >
                <mat-slide-toggle
                  formControlName="isHaveBlackListDeliveryProcess"
                  [(ngModel)]="model.isHaveBlackListDeliveryProcess"
                >
                  <app-expand-text [placement]="'left'">
                    <span small-text class="tw-leading-7">
                      {{
                        fields + "isHaveBlackListDeliveryProcess" | translate
                      }}
                    </span>
                    <div full-text class="full-text-display">
                      {{
                        fields + "isHaveBlackListDeliveryProcess" | translate
                      }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- IsCanSeePublicParentPhonebook -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isCanSeePublicParentPhonebook"
                  [(ngModel)]="model.isCanSeePublicParentPhonebook"
                >
                  <app-expand-text [placement]="'left'">
                    <span small-text class="tw-leading-7">
                      {{ fields + "isCanSeePublicParentPhonebook" | translate }}
                    </span>
                    <div full-text class="full-text-display">
                      {{ fields + "isCanSeePublicParentPhonebook" | translate }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- isSendAlertToOrganizationAdmin -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isSendAlertToOrganizationAdmin"
                  [(ngModel)]="model.isSendAlertToOrganizationAdmin"
                >
                  <app-expand-text [placement]="'left'">
                    <span small-text class="tw-leading-7">
                      {{
                        fields + "isSendAlertToOrganizationAdmin" | translate
                      }}
                    </span>
                    <div full-text class="full-text-display">
                      {{
                        fields + "isSendAlertToOrganizationAdmin" | translate
                      }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- isSendAlertForCreateSmartSmsRequest -->
              <div
                class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2"
                *ngIf="permissionService.userState()?.organizationId == 1"
              >
                <mat-slide-toggle
                  formControlName="isSendAlertForCreateSmartSmsRequest"
                  [(ngModel)]="model.isSendAlertForCreateSmartSmsRequest"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text class="tw-leading-7">
                      {{
                        fields + "isSendAlertForCreateSmartSmsRequest"
                          | translate
                      }}
                    </span>
                    <div full-text class="full-text-display">
                      {{
                        fields + "isSendAlertForCreateSmartSmsRequest"
                          | translate
                      }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- isSendOrganizationExpirationAlertMessage -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isSendOrganizationExpirationAlertMessage"
                  [(ngModel)]="model.isSendOrganizationExpirationAlertMessage"
                >
                  <app-expand-text [placement]="'left'">
                    <span small-text class="tw-leading-7">
                      {{
                        fields + "isSendOrganizationExpirationAlertMessage"
                          | translate
                      }}
                    </span>
                    <div full-text class="full-text-display">
                      {{
                        fields + "isSendOrganizationExpirationAlertMessage"
                          | translate
                      }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!--  isSendAlertForCreatePayment -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isSendAlertForCreatePayment"
                  [(ngModel)]="model.isSendAlertForCreatePayment"
                >
                  <app-expand-text [placement]="'left'">
                    <span small-text class="tw-leading-7">
                      {{ fields + "isSendAlertForCreatePayment" | translate }}
                    </span>
                    <div full-text class="full-text-display">
                      {{ fields + "isSendAlertForCreatePayment" | translate }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- isSendAlertForCreateOnlinePayment -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isSendAlertForCreateOnlinePayment"
                  [(ngModel)]="model.isSendAlertForCreateOnlinePayment"
                >
                  <app-expand-text [placement]="'left'">
                    <span small-text class="tw-leading-7">
                      {{
                        fields + "isSendAlertForCreateOnlinePayment" | translate
                      }}
                    </span>
                    <div full-text class="full-text-display">
                      {{
                        fields + "isSendAlertForCreateOnlinePayment" | translate
                      }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>
              <!-- isPostpaid -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isPostpaid"
                  [(ngModel)]="model.isPostpaid"
                >
                  {{ fields + "isPostpaid" | translate }}</mat-slide-toggle
                >
              </div>

              <!-- IsCanSendExtraReceivers -->
              <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4 tw-py-2">
                <mat-slide-toggle
                  formControlName="isCanSendExtraReceivers"
                  [(ngModel)]="model.isCanSendExtraReceivers"
                >
                  {{ fields + "isCanSendExtraReceivers" | translate }}</mat-slide-toggle
                >
              </div>
            </div>
          </div>
        </details>
      </section>

      <!-- adminUserId -->
      <section class="tw-mb-12">
        <details
          open
          class="tw-relative tw-bg-white dark:tw-bg-dark-500 tw-rounded-[5px] tw-border-[#29293d]"
          style="border-style: solid"
        >
          <summary
            class="tw-font-semibold tw-top-[-15px] tw-right-[15px] ltr:tw-left-[15px]"
          >
            <span class="tw-text-xl tw-font-semibold">
              {{ pageVocabs + "legends.organizationAdminUser" | translate }}
            </span>
          </summary>

          <div class="tw-p-4 tw-pt-10">
            <!-- adminUserId -->
            <div class="row" *ngIf="formPageConfig.isEditMode">
              <div class="md:tw-w-1/2">
                <users-select-search
                  type="organizationUsersList"
                  [label]="fields + 'adminUserId'"
                  [updateItems]="updateDistinctUsersList"
                  [id]="model.id"
                  [removable]="isSelectedOrganizationAdmin ? false : true"
                  [control]="form?.get('systemInformation.adminUserId')"
                  [(value)]="model.adminUserId"
                  (onError)="onClose()"
                >
                </users-select-search>
              </div>
            </div>

            <app-organization-admin-user-form
              *ngIf="!formPageConfig.isEditMode"
              [model]="user"
              (userForm)="userForm = $event"
            >
            </app-organization-admin-user-form>
          </div>
        </details>
      </section>

      <!-- role Information -->
      <section [class.d-none]="!model.adminUserId && formPageConfig.isEditMode">
        <details
          open
          class="tw-relative tw-bg-white dark:tw-bg-dark-500 tw-rounded-[5px] tw-border-[#29293d]"
          style="border-style: solid"
        >
          <summary
            class="tw-font-semibold tw-top-[-15px] tw-right-[15px] ltr:tw-left-[15px]"
          >
            <span class="tw-text-xl tw-font-semibold">
              {{ "common.roles" | translate }}
            </span>
          </summary>

          <div class="tw-p-4 tw-pt-10">
            <role-selection-list
              [isReadOnly]="!isAllowedEditRoles"
              type="organizationRoles"
              [id]="model.parentId"
              searchLabel="messages.searchInRoles"
              [values]="model.roleIds"
              (values)="model.roleIds = $event"
            >
            </role-selection-list>
          </div>
        </details>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
